var DadoCartograficoLimitrofe = /** @class */ (function () {
    function DadoCartograficoLimitrofe() {
    }
    return DadoCartograficoLimitrofe;
}());
export { DadoCartograficoLimitrofe };
